import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../styles/RegistrationStyle.css";
import React, { useContext, useState } from "react";
import { multiStepContext } from "./ContextApiComponent";
import { validateEmail, validateRequiredFields } from "./ValidationComponent";
import ".././.././../styles/CommonStyles.css";
import { VerificationRequest } from "../data/request/VerificationRequest";
import { VerificationResponse } from "../data/response/VerificationResponse";
import RegistrationClient from "../data/api/RegistrationClient";
import { useApi } from "../../../service/ApiContext";
import Logger from "../../../utils/Logger";
import { useAlert } from "../../../components/AlertContextComponent";
import strings from "../../../utils/Strings";
import Loader from "../../../utils/Utils";
import { validateEmailAddress } from "../../../utils/Validation";

const requiredFields = ["corporateEmail"];

const FirstStep: React.FC = () => {
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const { setCurrentStep, userData, setUserData, currentStep } =
    useContext(multiStepContext)!;
  const [errors, setErrors] = useState<any>({});
  const api = useApi();

  const verification = async () => {
    Loader.showLoading("Loading...");
    const param: VerificationRequest = {
      email_address: userData["corporateEmail"],
      entity: "USER",
    };
    try {
      const response = await api
        .post<VerificationResponse>(RegistrationClient.emailValidation, param)
        .then((res) => {
          if (res.data.error === null) {
            setCurrentStep(currentStep + 1);
          } else {
            showAlert({
              show: true,
              title: "Error",
              message: res.data.error,
              button1Text: "Cancel",
              alertType: "error",
              onlyNeedOneButton: true,
              btn1onPressed: () => navigate(strings.routing.signupPage),
            });
          }
          Logger.info("response", res.data);
        })
        .catch((error) => {
          Logger.info("error response", error);
        });
    } catch (error) {
      Logger.info("error response", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  const handleNext = () => {
    const checkError = validateRequiredFields(requiredFields, userData);

    if (!userData["corporateEmail"]?.trim()) {
      checkError["corporateEmail"] = "*Please enter a valid email address";
    } else if (!validateEmail(userData["corporateEmail"])) {
      checkError["corporateEmail"] = "*Please enter a valid email address";
    }

    setErrors(checkError);

    if (Object.keys(checkError).length === 0) {
      verification();
    }
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let email = e.target.value;

    // Prevent leading, trailing, or consecutive spaces
    email = email.replace(/^\s+|\s+(?=\s)|\s+$/g, "");

    // Update the state with the sanitized email
    setUserData({ ...userData, corporateEmail: email });

    // Validate the sanitized email
    if (!email) {
      setErrors((prevErrors: any) => ({
        ...prevErrors,
        corporateEmail: "*Please enter a valid email address",
      }));
    } else if (!validateEmailAddress(email)) {
      setErrors((prevErrors: any) => ({
        ...prevErrors,
        corporateEmail: "*Please enter a valid email address",
      }));
    } else {
      setErrors((prevErrors: any) => {
        const { corporateEmail, ...rest } = prevErrors;
        return rest;
      });
    }
  };

  return (
    <div className="FormStep" style={{width:"100%",justifyContent:"space-between",display:"flex",flexDirection:"column",height:"55vh"}}>
      <div className="form-input">
        <Form.Label htmlFor="corporateEmail">Enter Email*</Form.Label>
        <Form.Control
          className="rounded-input"
          type="email"
          id="corporateEmail"
          value={userData["corporateEmail"]}
          onChange={handleEmailChange}
          maxLength={64}
        />
        {errors.corporateEmail && (
          <div className="error-message">{errors.corporateEmail}</div>
        )}
      </div>
<div>
      <div className="form-button">
        <center>
         <button
  className="buttonForForm"
  style={{
    backgroundColor: userData["corporateEmail"]
      ? "#ffc85d"
      : "#eaeff9",
    cursor: userData["corporateEmail"]
      ? "pointer"
      : "not-allowed",
  }}
  onClick={handleNext}
  disabled={!userData["corporateEmail"]}
>
  Continue
</button>
        </center>
      </div>
      <p className="login-styling">
        Already have an Account?{" "}
        <span className="login-link" style={{color:"#2563eb"}} onClick={() => navigate("/")}>
          Login
        </span>
      </p>
      </div>
    </div>
  );
};

export default FirstStep;
